// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"CarHireOptionsHeader-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarHire/CarHireOptionsHeader.desktop.scss
 ** module id = 898
 ** module chunks = 1
 **/